import { Spacing } from '@persona-id/design-tokens';
import { VFC } from 'react';
import styled from 'styled-components';

import { WorkflowRunStatus } from 'dashboard/models/workflow-run';
import Sticker from 'design-system/components/Sticker';
import { Variant } from 'design-system/theme';

const StickerContainer = styled('div')`
  display: grid;
  grid-auto-columns: min-content;
  grid-auto-flow: column;

  grid-column-gap: ${Spacing[2]};
  grid-row-gap: ${Spacing[2]};
  white-space: nowrap;
`;

interface WorkflowRunStatusStickerProps {
  workflowRunStatus: WorkflowRunStatus;
  simulationTimedOut?: boolean;
}

const WorkflowRunStatusSticker: VFC<WorkflowRunStatusStickerProps> = ({
  workflowRunStatus,
  simulationTimedOut,
}) => {
  const getStickerStatus = (
    workflowRunStatus: WorkflowRunStatus,
  ): [Exclude<Variant, 'inverse'>, string] => {
    if (simulationTimedOut) {
      return ['danger', 'Errored'];
    }

    switch (workflowRunStatus) {
      case WorkflowRunStatus.Completed:
        return ['success', 'Completed'];
      case WorkflowRunStatus.Errored:
        return ['danger', 'Errored'];
      case WorkflowRunStatus.Failed:
        return ['danger', 'Failed'];
      case WorkflowRunStatus.Pending:
        return ['basic', 'Pending'];
      case WorkflowRunStatus.InProgress:
        return ['primary', 'In Progress'];
      default:
        return ['caution', 'Unknown'];
    }
  };

  const [variantType, statusMessage] = getStickerStatus(workflowRunStatus);

  return (
    <StickerContainer>
      <Sticker variant={variantType}>{statusMessage}</Sticker>
    </StickerContainer>
  );
};

export default WorkflowRunStatusSticker;
